// Module
var code = "<section> <cr-title-bar label=\"{{ ::$ctrl.text.title }}\" icon-class=\"icon-cr-mc-rocket\"></cr-title-bar> <iframe src=\"/mc-classic/index.html\"></iframe> </section> ";
// Exports
export default code;